import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import { Form } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { InvestorProfileFormData } from '../types';
import AnimatedContainer from './animated-container';
import { UploadComplianceLetter } from './upload-compliance-letter';
export const DeclarationsSection = () => {
  const $ = _c(122);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "collectInvestorProfile.declarations"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  const {
    control,
    resetField
  } = useFormContext();
  let t1;
  if ($[1] !== control) {
    t1 = {
      control,
      name: "isAffiliatedWithUsBroker"
    };
    $[1] = control;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isAffiliatedWithUsBroker = useWatch(t1);
  let t2;
  if ($[3] !== control) {
    t2 = {
      control,
      name: "isSeniorExecutive"
    };
    $[3] = control;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const isSeniorExecutive = useWatch(t2);
  let t3;
  if ($[5] !== control) {
    t3 = {
      control,
      name: "isSeniorPoliticalFigure"
    };
    $[5] = control;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const isSeniorPoliticalFigure = useWatch(t3);
  const shouldRequireUpload = isAffiliatedWithUsBroker || isSeniorExecutive;
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <h2 className="text-label-2 text-primary">{t4}</h2>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp2);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== resetField) {
    t7 = e => {
      if (!e.target.checked) {
        resetField(diToFormData("investor_profile.brokerage_firm_employer"));
      }
    };
    $[13] = resetField;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <Form.Checkbox name="isAffiliatedWithUsBroker" label={t6} onChange={t7} />;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = diToFormData("investor_profile.brokerage_firm_employer");
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp3);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp4);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t(_temp5);
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = {
      required: t12
    };
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t13) {
    t14 = <div className="pl-6"><Form.Input name={t9} size="compact" label={t10} placeholder={t11} rules={t13} /></div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== isAffiliatedWithUsBroker || $[32] !== t14) {
    t15 = <AnimatedContainer isExpanded={isAffiliatedWithUsBroker}>{t14}</AnimatedContainer>;
    $[31] = isAffiliatedWithUsBroker;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t15 || $[35] !== t8) {
    t16 = <div className="flex flex-col gap-3">{t8}{t15}</div>;
    $[34] = t15;
    $[35] = t8;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t) {
    t17 = t(_temp6);
    $[37] = t;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== resetField) {
    t18 = e_0 => {
      if (!e_0.target.checked) {
        resetField(diToFormData("investor_profile.senior_executive_symbols"));
      }
    };
    $[39] = resetField;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t17 || $[42] !== t18) {
    t19 = <Form.Checkbox name="isSeniorExecutive" label={t17} onChange={t18} />;
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = diToFormData("investor_profile.senior_executive_symbols");
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t) {
    t21 = t(_temp7);
    $[45] = t;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t) {
    t22 = t(_temp8);
    $[47] = t;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t) {
    t23 = t(_temp9);
    $[49] = t;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t) {
    t24 = t(_temp10);
    $[51] = t;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t24) {
    t25 = {
      required: t24
    };
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t21 || $[56] !== t22 || $[57] !== t23 || $[58] !== t25) {
    t26 = <div className="pl-6"><Form.Input name={t20} size="compact" label={t21} placeholder={t22} hint={t23} rules={t25} /></div>;
    $[55] = t21;
    $[56] = t22;
    $[57] = t23;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== isSeniorExecutive || $[61] !== t26) {
    t27 = <AnimatedContainer isExpanded={isSeniorExecutive}>{t26}</AnimatedContainer>;
    $[60] = isSeniorExecutive;
    $[61] = t26;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== t19 || $[64] !== t27) {
    t28 = <div className="flex flex-col gap-3">{t19}{t27}</div>;
    $[63] = t19;
    $[64] = t27;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== t) {
    t29 = t(_temp11);
    $[66] = t;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== resetField) {
    t30 = e_1 => {
      if (!e_1.target.checked) {
        resetField(diToFormData("investor_profile.family_member_names"));
        resetField(diToFormData("investor_profile.political_organization"));
      }
    };
    $[68] = resetField;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== t29 || $[71] !== t30) {
    t31 = <Form.Checkbox name="isSeniorPoliticalFigure" label={t29} onChange={t30} />;
    $[70] = t29;
    $[71] = t30;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = diToFormData("investor_profile.family_member_names");
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  let t33;
  if ($[74] !== t) {
    t33 = t(_temp12);
    $[74] = t;
    $[75] = t33;
  } else {
    t33 = $[75];
  }
  let t34;
  if ($[76] !== t) {
    t34 = t(_temp13);
    $[76] = t;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] !== t) {
    t35 = t(_temp14);
    $[78] = t;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  let t36;
  if ($[80] !== t) {
    t36 = t(_temp15);
    $[80] = t;
    $[81] = t36;
  } else {
    t36 = $[81];
  }
  let t37;
  if ($[82] !== t36) {
    t37 = {
      required: t36
    };
    $[82] = t36;
    $[83] = t37;
  } else {
    t37 = $[83];
  }
  let t38;
  if ($[84] !== t33 || $[85] !== t34 || $[86] !== t35 || $[87] !== t37) {
    t38 = <Form.Input name={t32} size="compact" label={t33} placeholder={t34} hint={t35} rules={t37} />;
    $[84] = t33;
    $[85] = t34;
    $[86] = t35;
    $[87] = t37;
    $[88] = t38;
  } else {
    t38 = $[88];
  }
  let t39;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = diToFormData("investor_profile.political_organization");
    $[89] = t39;
  } else {
    t39 = $[89];
  }
  let t40;
  if ($[90] !== t) {
    t40 = t(_temp16);
    $[90] = t;
    $[91] = t40;
  } else {
    t40 = $[91];
  }
  let t41;
  if ($[92] !== t) {
    t41 = t(_temp17);
    $[92] = t;
    $[93] = t41;
  } else {
    t41 = $[93];
  }
  let t42;
  if ($[94] !== t) {
    t42 = t(_temp18);
    $[94] = t;
    $[95] = t42;
  } else {
    t42 = $[95];
  }
  let t43;
  if ($[96] !== t42) {
    t43 = {
      required: t42
    };
    $[96] = t42;
    $[97] = t43;
  } else {
    t43 = $[97];
  }
  let t44;
  if ($[98] !== t40 || $[99] !== t41 || $[100] !== t43) {
    t44 = <Form.Input name={t39} size="compact" label={t40} placeholder={t41} rules={t43} />;
    $[98] = t40;
    $[99] = t41;
    $[100] = t43;
    $[101] = t44;
  } else {
    t44 = $[101];
  }
  let t45;
  if ($[102] !== t38 || $[103] !== t44) {
    t45 = <div className="pl-6 flex flex-col gap-3">{t38}{t44}</div>;
    $[102] = t38;
    $[103] = t44;
    $[104] = t45;
  } else {
    t45 = $[104];
  }
  let t46;
  if ($[105] !== isSeniorPoliticalFigure || $[106] !== t45) {
    t46 = <AnimatedContainer isExpanded={isSeniorPoliticalFigure}>{t45}</AnimatedContainer>;
    $[105] = isSeniorPoliticalFigure;
    $[106] = t45;
    $[107] = t46;
  } else {
    t46 = $[107];
  }
  let t47;
  if ($[108] !== t31 || $[109] !== t46) {
    t47 = <div className="flex flex-col gap-3">{t31}{t46}</div>;
    $[108] = t31;
    $[109] = t46;
    $[110] = t47;
  } else {
    t47 = $[110];
  }
  let t48;
  if ($[111] !== shouldRequireUpload) {
    t48 = <UploadComplianceLetter isRequired={shouldRequireUpload} />;
    $[111] = shouldRequireUpload;
    $[112] = t48;
  } else {
    t48 = $[112];
  }
  let t49;
  if ($[113] !== shouldRequireUpload || $[114] !== t48) {
    t49 = <AnimatedContainer isExpanded={shouldRequireUpload}>{t48}</AnimatedContainer>;
    $[113] = shouldRequireUpload;
    $[114] = t48;
    $[115] = t49;
  } else {
    t49 = $[115];
  }
  let t50;
  if ($[116] !== t16 || $[117] !== t28 || $[118] !== t47 || $[119] !== t49 || $[120] !== t5) {
    t50 = <section className="flex flex-col gap-6">{t5}{t16}{t28}{t47}{t49}</section>;
    $[116] = t16;
    $[117] = t28;
    $[118] = t47;
    $[119] = t49;
    $[120] = t5;
    $[121] = t50;
  } else {
    t50 = $[121];
  }
  return t50;
};
export default DeclarationsSection;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.options.affiliatedWithUsBroker;
}
function _temp3($_1) {
  return $_1.brokerageFirmEmployer.label;
}
function _temp4($_2) {
  return $_2.brokerageFirmEmployer.placeholder;
}
function _temp5($_3) {
  return $_3.brokerageFirmEmployer.error;
}
function _temp6($_4) {
  return $_4.options.seniorExecutive;
}
function _temp7($_5) {
  return $_5.companySymbols.label;
}
function _temp8($_6) {
  return $_6.companySymbols.placeholder;
}
function _temp9($_7) {
  return $_7.companySymbols.hint;
}
function _temp10($_8) {
  return $_8.companySymbols.error;
}
function _temp11($_9) {
  return $_9.options.seniorPoliticalFigure;
}
function _temp12($_10) {
  return $_10.familyMembers.label;
}
function _temp13($_11) {
  return $_11.familyMembers.placeholder;
}
function _temp14($_12) {
  return $_12.familyMembers.hint;
}
function _temp15($_13) {
  return $_13.familyMembers.error;
}
function _temp16($_14) {
  return $_14.politicalOrganization.label;
}
function _temp17($_15) {
  return $_15.politicalOrganization.placeholder;
}
function _temp18($_16) {
  return $_16.politicalOrganization.error;
}